import FormPageSingle from '../../components/Pages/FormPageSingle/FormPageSingle';
import { serviceTypes } from '../initData/services';
import { pages } from '../pageTypes';
import PageWrapper from './PageWrapper';

export default function FormPageSingleWrapper({
  addressInput,
  serviceId,
  cityId,
  ageId,
  robotId,
  locationId,
  occurrenceId,
}) {
  const isWorkshopService = serviceId === serviceTypes.workshop;
  const isSummerplayService = serviceId === serviceTypes.summerplay;
  const isAcademyService = serviceId === serviceTypes.academy;
  let shouldBePage = pages.contactSingleService;
  let conditionTypes = {
    page: true,
    service: true,
    franchise: true,
    robot: isWorkshopService,
    age: isWorkshopService,
    workshops: isWorkshopService,
    location: true,
    summerplays: isSummerplayService,
    academies: isAcademyService,
    occurrence: true,
  };

  if (addressInput) {
    shouldBePage = pages.contactWithAddress;
    conditionTypes.workshops = false;
    conditionTypes.occurrence = false;
  }

  return (
    <PageWrapper
      pageToLoad={<FormPageSingle />}
      shouldBePage={shouldBePage}
      serviceId={serviceId}
      cityId={cityId}
      ageId={ageId}
      robotId={robotId}
      locationId={locationId}
      occurrenceId={occurrenceId}
      conditions={conditionTypes}
    />
  );
}
